import { render, staticRenderFns } from "./loginAccount.vue?vue&type=template&id=648644a0&"
import script from "./loginAccount.vue?vue&type=script&lang=ts&"
export * from "./loginAccount.vue?vue&type=script&lang=ts&"
import style0 from "./loginAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports